import { render } from "./BaseViewHeaderPrimaryBtn.vue?vue&type=template&id=7057021b"
import script from "./BaseViewHeaderPrimaryBtn.vue?vue&type=script&lang=js"
export * from "./BaseViewHeaderPrimaryBtn.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__